export default __webpack_public_path__ + "static/media/Licenses_BG-03.0749c3bf.png";